import { Button, Form, Modal, Select, message } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { AdminService } from "../../../../../services";
import { ModalHeader } from "datastake-daf/dist/components";
import { MODAL_WIDTH } from "../../config";
import Footer from "../../../../../components/dashboards/components/project-visualisation/components/Footer";

export default function TransferRightsModal({
  transferRightsUser = null,
  onClose = () => { },
  dataSource = [],
  fetchUsers = () => { },
}) {
  const { t } = useTranslation();
  const [value, setValue] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const company = useMemo(() => {
    if (transferRightsUser) {
      const _company = dataSource.find((s) => s._id === transferRightsUser.company);
      return _company;
    }

    return null;
  }, [dataSource, transferRightsUser]);

  const options = useMemo(() => {
    if (company) {
      return company.users.filter((u) => u.id !== transferRightsUser.id && u.status === 'active').map((u) => ({
        label: `${u.firstName} ${u.lastName}`,
        value: u.id,
      }));
    }

    return [];
  }, [company, transferRightsUser]);

  useEffect(() => {
    if (!transferRightsUser) {
      setValue(null);
    }
  }, [transferRightsUser]);

  const _onSubmit = async () => {
    setIsLoading(true);
    try {
      await AdminService.transferRights(company.id, value)
      onClose();
      fetchUsers({});
    } catch (err) {
      console.log(err);
      message.err(t(err.message || 'Error transfering rights'));
    }

    setIsLoading(false);
  };

  return (
    <Modal
      wrapClassName="bordered-footer"
      open={!!transferRightsUser}
      onCancel={onClose}
      title={(
        <ModalHeader
          title={t('Transfer Administrator Rights')}
        />
      )}
      width={MODAL_WIDTH}
      footer={[
        <Footer
          t={t}
          key="footer"
          className="mt-0"
          onSubmit={_onSubmit}
          onClose={onClose}
          disabledFooter={!value || isLoading}
        />
      ]}

    >
      <Form layout="vertical">
        <Form.Item label={t('Select New Administrator')}>
          <Select placeholder={t('Select User')} value={value} onChange={(v) => setValue(v)}>
            {options.map((role) => (
              <Select.Option value={role.value} key={role.value}>
                {role.label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  )
}
